import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { TripPlanComponent } from './trip-plan.component';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule],
  declarations: [TripPlanComponent],
  exports: [TripPlanComponent],
  providers: [],
})
export class TripPlanComponentModule {}
